import instance from "../root.api";

export const appInfoRequest = () =>
    instance.get("/app-info").then((response) => ({response}));
